export const loginUrl = `/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/login`;
export const loginUrl2 = `/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/login`;
export const mapUrl = `/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/map`;
export const loginUrlSuppliers = `${process.env.REACT_APP_LOGIN_TO_SUPPLIER_PLATFORM_URL}`;